module.exports = __webpack_public_path__ + "img/ski10.482a8842.jpg";